export const AI_MODEL_CHOICE_OPTIONS = [
  'auto',
  'di',
  'ai_foundry',
  'di_plus_ai_foundry',
] as const;

export const AI_MODEL_TYPE_OPTIONS = ['di', 'ai_foundry'] as const;

export const LANGUAGE_ENCODING_OPTIONS = ['DE', 'US', 'PL'] as const;

export const LVLM_PERFORMANCE_MODES = ['high', 'medium'] as const;
export const LVLM_USAGE = ['auto', 'true', 'false', 'shadowing'] as const;

export const PROCESS_BULK_OPTIONS = ['auto', 'true', 'false'] as const;
